export default "__VITE_PUBLIC_ASSET__745737ca__"